import { IController } from 'angular';
import * as _ from 'lodash';
import { IStoreScope } from './../../../../../../sdc/flux/sdc-store.interface';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class PrintRegentsCtrl implements IController {
  static $inject = ['$scope', 'StudentReportModal', 'WizardUtils'];

  public filteredStudents_Ids;
  public count;

  constructor(public $scope: IStoreScope, private StudentReportModal, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    const filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.filteredStudents_Ids = _.map(filteredStudents, '_id');
    this.count = this.filteredStudents_Ids.length;
  }

  openStudentReportModal = event => {
    this.StudentReportModal.show(this.filteredStudents_Ids, 'regentsSched');
  };
}
